import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dialog } from '@material-ui/core';
import { Group } from '@mui/icons-material';
import { withRouter } from 'react-router-dom';

class App extends Component {
  state={ open: true }
  renderCheckDialog=() => (
    <div style={{ width: 515, height: 458, backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
      <Group style={{ marginTop: 15, width: '162', height: '185', color: '#5A397E' }} />
      <div style={{ fontSize: 25 }}>帳號清查</div>
      <div style={{ color: '#AAAAAA', fontSize: 25, marginBottom: 25, marginTop: 8, marginRight: 12, marginLeft: 12 }}>前往「個人資料維護管理」頁面，確認基本資料後如資料有誤，請逕行修正並點選右下角「帳號確認並儲存」按鈕。</div>
      <div style={{ display: 'flex' }}>
        <Button style={{ height: 47, width: 165, backgroundColor: '#66D4DB', color: 'white', borderRadius: 8 }} onClick={() => this.setState({ open: false }, () => this.props.history.push('/Main/system/account/personal_account_manager'))}>確認</Button>
      </div>
    </div>
  )

  render () {
    const { session = {} } = this.props;
    const { data = {} } = session;
    const { need_user_check = false } = data;
    const { open } = this.state;
    return (
      <Dialog
        PaperComponent={ this.renderCheckDialog}
        open={need_user_check && open}
      />
    );
  }
}

const mapStateToProps = state => ({
  session: state.session,
});
const mapDispatchToProps = dispatch => ({
});
const APP = connect(mapStateToProps, mapDispatchToProps)(withRouter(App));

export default APP;
